import type { UUID } from '@cmg/common';
import type { CustomCellRendererProps } from '@cmg/data-grid';
import { Link, useParams } from 'react-router-dom';

import { useRoutes } from '../../../../../common/hooks/useRoutes/useRoutes';
import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export function EmployeeKeyCellRenderer({
  value,
}: Readonly<CustomCellRendererProps<UnderwriterEmployeeFragment, string>>) {
  const { crmIntegrationId } = useParams<{ crmIntegrationId?: UUID }>();

  const { crmSalesCoverageEmployee } = useRoutes(crmIntegrationId);

  if (!value) {
    return <span>-</span>;
  }
  return (
    <Link to={crmSalesCoverageEmployee.getUrlPath({ crmIntegrationId, employeeKey: value })}>
      {value}
    </Link>
  );
}
